
import CrudArrayComponent from '@/components/CrudArrayComponent.vue';
import EntidadeLinkComponent from '@/components/EntidadeLinkComponent.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import { ICheckoutUpdate } from '@/interfaces/checkout';
import { ICheckoutAnswer } from '@/interfaces/checkout_answer';
import { IUserProfile } from '@/interfaces/user_profile';
import {
  adminStore,
  checkoutAnswerQuestionStore,
  checkoutAnswerStore,
  checkoutQuestionStore,
  checkoutStore,
  mainStore,
  userActionStore,
} from '@/store';
import _ from 'lodash';
import { Component, Watch } from 'vue-property-decorator';
import Authorize from './Authorize.vue';
import TemplateCheckout from './TemplateCheckout.vue';
import UploadFilesCheckout from './uploadFilesCheckout.vue';

@Component({
  components: {
    Authorize,
    CrudArrayComponent,
    EntidadeLinkComponent,
    UploadFilesCheckout,
    ShowPopup,
  },
})
export default class CheckoutList extends TemplateCheckout {
  @Watch('showAll')
  async onChangeShowAll(val) {
    this.loading = true;
    if (val) {
      await checkoutAnswerStore.getCheckoutAnswersQuery({
        checkoutId: this.checkoutId!,
      });
    } else {
      await checkoutAnswerStore.getCheckoutAnswersQuery({
        checkoutId: this.checkoutId!,
        limit: 1000,
      });
    }
    this.loading = false;
  }

  get headers() {
    const headers = [
      {
        text: 'Unidade',
        sortable: true,
        value: 'company.nome_fantasia',
        align: 'left',
      },
      {
        text: 'Protocolo',
        sortable: true,
        value: 'answer_count',
        align: 'left',
      },
      {
        text: 'Criado em',
        sortable: true,
        value: 'created_at',
        align: 'left',
      },
      {
        text: 'Criado por',
        sortable: true,
        value: 'user.full_name',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'actions',
      },
    ];

    // Processo Judicial - Mostrar CNPJ
    if (this.checkoutId == 198) {
      headers.splice(1, 0, {
        text: 'CNPJ',
        sortable: true,
        value: 'company.cnpj',
        align: 'left',
      });
    }

    return headers;
  }

  public created_by_id = 0;
  public propState = 0;
  public tableId = 0;
  public tableName = '';

  public checkoutId: null | number = null;

  public currentCheckout: any = {};

  public showAll = false;

  get actionEmailsRecebendoAtualizacoes() {
    return userActionStore.EmailsRecebendoAtualizaçõesCheckout;
  }

  get ExcluirCheckoutJuridico() {
    return userActionStore.ExcluirCheckoutJuridico;
  }

  get notAllowed() {
    return _.some([
      this.checkoutId === 80 && !(userActionStore.CriarCheckoutBonificacao || this.userProfile!.is_superuser),
    ]);
  }

  public headersQuestions = [];

  public search = '';

  public selectedItem = {};

  public expanded = [];

  public loading = true;

  public temArquivo = 0;

  public loadingDetails = true;

  public loadingQuestions = true;

  public checkout_files = [];

  public emails: Object[] = [];

  public users: IUserProfile[] = [];

  get usersFiltered() {
    return _.filter(
      this.users,
      (u) =>
        (u.email.includes('@knnidiomas.com') ||
          u.email.includes('@knnbrasil.com') ||
          u.email.includes('@phenomidiomas.com') ||
          u.email.includes('@phenombrasil.com')) &&
        !_.includes(_.map(this.emails, 'email'), u.email)
    );
  }

  public getAllowEdit(id: number) {
    return (
      (this.checkoutTool.allow_edit && this.currentCheckout['allow_edit'] && this.userProfile!.id! === id) ||
      this.userProfile!.is_superuser ||
      this.editarQualquerCheckoutAction
    );
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  public async updateCheckoutEmails(items) {
    if (_.isEqual(this.currentCheckout.emails, _.map(items, 'email'))) return;

    const payload: ICheckoutUpdate = {
      id: this.checkoutId,
      emails: [],
    };
    items.forEach((item) => {
      //@ts-ignore
      payload.emails.push(item.email);
    });
    checkoutStore.updateCheckout(payload);
  }

  public dataDetails() {
    if (this.checkoutAnswerQuestions) {
      let a = this.checkoutAnswerQuestions.map((item) => {
        //@ts-ignore
        let key = item.checkout_question_id;
        return { [key]: item.answer };
      });
      if (a.length > 0) {
        //@ts-ignore
        let b = Object.assign(...a);
        return [b];
      }
    }
  }

  public handleUploadFile(item: any) {
    this.tableId = item.id;
    this.tableName = String(item.checkout_id) + 'checkout';
    this.created_by_id = item.user_id;
    let form: any = this.$refs.showFiles;
    form.show();
  }
  public get checkoutAnswers() {
    return checkoutAnswerStore.checkoutAnswers;
  }

  public get checkoutQuestions() {
    return checkoutQuestionStore.checkoutQuestions;
  }

  public get checkoutAnswerQuestions() {
    return checkoutAnswerQuestionStore.checkoutAnswerQuestions;
  }

  public async deleteCheckoutAnswer(item) {
    this.checkout_files = await checkoutStore.getFilesCheckout({
      table_name: String(item.checkout_id) + 'checkout',
      id: item.id,
    });

    if (this.checkout_files.length > 0) {
      this.$swal.fire(
        'Existem arquivos em anexo a este checkout!',
        'Exclua os arquivos para depois excluir o checkout...',
        'error'
      );
    } else {
      this.$swal({
        title: 'Confirma a exclusão do checkout?',
        text: 'Após a exclusão o checkout não pode ser recuperado!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, eu confirmo!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await checkoutAnswerStore.deleteCheckoutAnswer(item.id);
          await checkoutAnswerStore.getCheckoutAnswersQuery({
            checkoutId: this.checkoutId!,
          });
        }
      });
    }
  }

  public async getCheckoutAnswerQuestion({ item }) {
    this.loadingDetails = true;
    await checkoutAnswerQuestionStore.getCheckoutAnswerQuestions(item.id);
    this.loadingDetails = false;
  }

  public async showCheckout(item) {
    this.selectedItem = item;
    let form: any = this.$refs.authorize;
    form.show(item.id);
  }

  public async mounted() {
    const params = _.get(this.$router.currentRoute, 'params', {});
    const checkoutId = _.get(params, 'checkoutId');

    if (checkoutId) {
      this.checkoutId = _.toNumber(checkoutId);
    }

    if (this.checkoutId) {
      this.loading = true;

      await checkoutStore.getCheckoutById(this.checkoutId);
      this.currentCheckout = checkoutStore.checkout;

      if (this.currentCheckout.franchising_id !== this.userProfile?.franchising_id && !this.userProfile?.is_superuser) {
        this.$swal({
          title: 'Checkout não autorizado',
          text: 'Você está tentando ver um checkout que não é da sua franquia.',
          icon: 'error',
        }).then(() => {
          this.$router.back();
        });
      }

      let emails = await checkoutStore.getCheckoutEmails(Number(this.checkoutId));

      if (emails) {
        this.emails = emails!.map((e) => {
          return { email: e };
        });
      }

      await checkoutAnswerStore.getCheckoutAnswersQuery({
        checkoutId: this.checkoutId,
        limit: 1000,
      });

      this.loading = false;
      this.loadingQuestions = true;
      await checkoutQuestionStore.getCheckoutQuestions(this.checkoutId);

      this.users = adminStore.usersFranchising;
      this.loadingQuestions = false;

      //@ts-ignore
      this.headersQuestions = checkoutQuestionStore.checkoutQuestions.map((value) => {
        if (value.type != 'label') {
          if (value.type == 'file') {
            this.temArquivo = 1;
          }
          return {
            text: value.question,
            sortable: false,
            value: String(value.id),
            align: 'left',
          };
        }
      });
    } else {
      this.$router.push('/main/checkout/all');
    }
  }

  public routeEdit(checkoutAnswer: ICheckoutAnswer) {
    this.$router.push({
      name: 'main-checkout-answers-edit',
      params: {
        checkoutId: _.toString(checkoutAnswer.checkout_id),
        checkoutAnswerId: _.toString(checkoutAnswer.id),
      },
    });
  }

  public async routeCreate() {
    await checkoutStore.getCheckoutById(this.checkoutId);

    this.$router.push({
      name: 'main-checkout-answers-create',
      params: { checkoutId: this.currentCheckout.id },
    });
  }
}
